import { render } from "./PanelTipsterPaises.vue?vue&type=template&id=4cae75dd&scoped=true"
import script from "./PanelTipsterPaises.vue?vue&type=script&lang=js"
export * from "./PanelTipsterPaises.vue?vue&type=script&lang=js"

import "./PanelTipsterPaises.vue?vue&type=style&index=0&id=4cae75dd&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cae75dd"]])

export default __exports__